export default __webpack_public_path__ + "static/media/s-isch-mer-alles-ei-ding.152f92e2.png";